export default __webpack_public_path__ + "static/media/chart.f4421310.svg";